import {subdomainResource, subdomainLink} from '../helpers/url'
import moment from 'moment'
import command from '../helpers/command'

export async function saveUpload({name, subject, grade, file}) {
  const upload = command('teacher', 'save_upload')
  const [{id}] = await upload({
    Name: name,
    Subject: subject,
    Grade: grade
  })
  return command('teacher', 'hash')({id, file})
}

export function saveTemplate (name, plan) {
  const save = command('teacher', 'saveTemplate', {method: 'POST'})
  const items = plan.items.map(({name,content}, order) => ({name, order, content}))
  return save({name, items})
}

export function saveRDTemplate (name, plan) {
  const save = command('teacher', 'saveTemplate', {method: 'POST'})
  const items = plan.items.map(({name,element}, order) => ({name, order, element}))
  return save({name:`rd-${name}`, items})
}

export function scheduleAssessment ({id, title, language, course, message, action, students, start, finish, maxTime}) {
  const schedule = command('teacher', 'schedule_event', {method: 'POST'})
  return schedule({
    Type: 'a.assignment',
    Title: id,
    Clique: students[0].teacher,
    Content: {
      title: title || message,
      course,
      language,
      message,
      subject: course.substring(0,2),
      linked: true
    },
    MaxTime: maxTime,
    Start: moment(start).toISOString(),
    Finish: moment(finish).toISOString(),
    Students: students.map(({id}) => id)
  })
}

export function scheduleComment ({language, subject, message, action, students, date}) {
  const schedule = command('teacher', 'schedule_event', {method: 'POST'})
  const isoDate = moment(date).toISOString()
  return schedule({
    Type: 'comment',
    Title: 'comment',
    Clique: students[0].teacher,
    Content: {
      language: language,
      message: message,
      subject: subject,
      linked: false
    },
    Start: isoDate,
    Finish: isoDate,
    Students: students.map(({id}) => id)
  })
}

export function scheduleEvent ({lesson, language, message, action, students, date}) {
  const schedule = command('teacher', 'schedule_event', {method: 'POST'})
  const isoDate = moment(date).toISOString()
  return schedule({
    Type: 'schedule',
    Title: lesson.id,
    Clique: students[0].teacher,
    Content: {
      language: language,
      message: message,
      subject: lesson.id.substring(0,2),
      linked: action == 'schedule'
    },
    Start: isoDate,
    Finish: isoDate,
    Students: students.map(({id}) => id)
  })
}

export function scheduleUpload ({upload, profile, url, language, message, action, students, date}) {
  const schedule = command('teacher', 'schedule_event', {method: 'POST'})
  const isoDate = moment(date).toISOString()
  return schedule({
    Type: 'uploaded',
    Title: upload.id,
    Clique: students[0].teacher,
    Content: {
      title: upload.name,
      language,
      url: subdomainLink('download', profile.domain, profile.Passport.userName, 'lesson', name),
      message,
      subject: upload.subject,
      linked: action == 'schedule'
    },
    Start: isoDate,
    Finish: isoDate,
    Students: students.map(({id}) => id)
  })
}

export function editSchedule ({content, event, group, language, message, action, students, date}) {
  const schedule = command('teacher', 'schedule_event', {method: 'POST'})
  const isoDate = moment(date).toISOString()
  return schedule({
    Type: 'schedule',
    Event: event,
    Clique: students[0].teacher,
    Content: {
      ...content,
      language: language,
      message: message,
      subject: group.course.substring(0,2),
      linked: action == 'schedule'
    },
    Start: isoDate,
    Finish: isoDate,
    Students: students.map(({id}) => id)
  })
}

export function editAssessmentSchedule ({title, content, event, group, language, message, action, students, start, finish, maxTime}) {
  const schedule = command('teacher', 'schedule_event', {method: 'POST'})
  const isoDate = date => moment(date).toISOString()

  const args = {
    Type: 'a.assignment',
    Title: title,
    Event: event,
    Clique: students[0].teacher,
    Content: {
      ...content,
      language: language,
      message: message,
      max_time: maxTime,
      subject: group.course.substring(0,2),
      linked: action == 'schedule'
    },
    MaxTime: maxTime,
    Start: isoDate(start),
    Finish: isoDate(finish),
    Students: students.map(({id}) => id)
  }

  return schedule(args)
}

export function rescheduleEvent (id, start, finish) {
  const schedule = command('teacher', 'reschedule_event', {method: 'GET'})
  return schedule({
    Event: id,
    Start: moment(start).toISOString(),
    Finish: moment(finish).toISOString()
  })
}

export function deleteEvent (id) {
  return command('teacher', 'delete_schedule', {method: 'GET'})({
    Event: id
  })
}

export function deletePlanTemplate (id) {
  return command('teacher', 'deletePlanTemplate', {method: 'GET'})({id})
}

export function renamePlanTemplate (id, name) {
  return command('teacher', 'renamePlanTemplate', {method: 'GET'})({id, name})
}

export function sendAssessment (teacher, assessment) {
  return command('teachers', `${teacher}/assessment_templates/${assessment.id}`, {method: 'PUT', server: subdomainResource('assessment')})(assessment)
}

export function deleteAssessment (teacher, assessment) {
  return command('teachers', `${teacher}/assessment_templates/${assessment}`, {method: 'DELETE', server: subdomainResource('assessment')})()
}

export function cloneAssessment ({teacher, id}, name) {
  return command('teachers', `${teacher}/assessment_templates/${id}/deep_copy`, {
    method: 'POST',
    server: subdomainResource('assessment'),
    sendAsArgs: true
  })({name})
}

export function savePlan (plan, template) {
  const save = command('teacher', 'savePlan', {method: 'POST'})
  const items = plan.items.map(({name,content}, order) => ({name, order, content}))
  return save({...plan, items, template})
}

export function reschedulePlan (plan, start, finish) {
  const schedule = command('teacher', 'reschedulePlan', {method: 'GET'})
  return schedule({
    plan, start: moment(start).toISOString(),
    finish: moment(finish).toISOString()
  })
}

export function deletePlan (id) {
  return command('teacher', 'deletePlan', {method: 'GET'})({id})
}

export function deleteCycle (id) {
  return command('planning', 'deleteCycle', {method: 'GET'})({id})
}

export function createCycle (start, finish, content) {
  return command('planning', 'createCycle', {method: 'POST'})({start, finish, content})
}
 
export function editCycle (id, start, finish, content) {
  return command('planning', 'editCycle', {method: 'POST'})({id, start, finish, content})
}

export function duplicatePlan (options) {
  const {start, end} = options
  return command('teacher', 'duplicatePlan', {method: 'POST'})(
  {
    ...options,
    start: moment(start).toISOString(),
    end: moment(end).toISOString()
  })
}

export function switchToClassic(error) {
  const update = command('teacher', 'updateProperties', {method: error ? 'POST' : 'GET'})
  return update({newEduSystemAsked: true, style: 'classic', error})
}

export function uiInformed(error) {
  const update = command('teacher', 'updateProperties', 'GET')
  return update({uiInformed: true})
}

export function logout() {
  return command('security', 'logout')()
}

export function deleteUploadedLesson (id, lesson) {
  const moxie = command(null, 'api.php', {method: 'GET', server: subdomainResource('moxie')})({
    json: JSON.stringify({
    id: 'qwertyGoogleThunder',
    method: 'Delete',
    jsonrpc: '2.0',
    params: {
      paths: [`/lesson/${lesson}`]
    }})
  })
  const download = command('teacher', 'delete_upload', 'GET')({Upload: id}) 
  return Promise.all([moxie, download])
}
